import { useEffect, useState, useCallback, useRef } from "react";

export function useQuery(queryFn, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tick, setTick] = useState(0);
  const hasData = useRef(false);

  const stableFn = useCallback(queryFn, deps);

  const refetch = useCallback(() => setTick((t) => t + 1), []);

  useEffect(() => {
    let cancelled = false;

    if (!hasData.current) setLoading(true);

    stableFn()
      .then((result) => {
        if (!cancelled) {
          setData(result);
          hasData.current = true;
        }
      })
      .catch((err) => {
        console.error("[useQuery] Error:", err);
        if (!cancelled) setError(err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [stableFn, tick]);

  return { data, loading, error, refetch };
}
